// Runtime settings keys
export const DISTANCE_CALCULATING_ENABLED_CONFIG_KEY = 'distance-calculating.enabled';
export const YANDEX_API_KEY_CONFIG_KEY = 'builders.YandexApiKey';
export const YANDEX_SUGGEST_API_KEY_CONFIG_KEY = 'builders.YandexSuggestApiKey';
export const YANDEX_VERSION_CONFIG_KEY = 'builders.YandexApiVersion';

export const YANDEX_API_TELEMETRY_KEY = 'yandexApi.requestsCount';

export const MAX_DISPLAY_TRANSPORT_ACCESSIBILITY_ONBOARDING_COUNT = 3;
export const TRANSPORT_ACCESSIBILITY_ONBOARDING_COOKIE_KEY = 'transport-accessibility_onboarding_counter';

export const MAP_CONTAINER_ID = 'mapsSection';
